import { AuthUser } from '@/models';

export default class AuthorizationService {
  _authApiService;
  _tokenSyncService;

  constructor(authApiService, tokenSyncService) {
    this._authApiService = authApiService;
    this._tokenSyncService = tokenSyncService;
  }

  async authorize(accessToken) {
    try {
      const { userRoles, userId } = AuthorizationService._parseAccessToken(accessToken);
      const { idToken } = this._tokenSyncService.tokens;

      return new AuthUser({
        id: userId,
        roles: userRoles,
        name: AuthorizationService._parseIdToken(idToken),
      });
    } catch (e) {
      console.error(e, 'while trying to authorize');
      throw e;
    }
  }

  async logout(refreshToken, mapper) {
    try {
      await this._authApiService.logout(refreshToken, mapper);
      this._tokenSyncService.remove();
    } catch (e) {
      console.error(e, 'while trying to logout');
      throw e;
    }
  }

  static _parseAccessToken(accessToken) {
    const {
      aud: userRoles,
      sub: userId,
    } = JSON.parse(atob(accessToken.split('.')[1]));

    return {
      userRoles,
      userId,
    };
  }

  static _parseIdToken(idToken) {
    const { email } = JSON.parse(atob(idToken.split('.')[1]));

    return email;
  }
}
